import Img15 from '../Assets/ps4.png'
import Img16 from '../Assets/Nintendo.png'
import Img17 from '../Assets/amd.png'
import Img18 from '../Assets/ps4pad.png'
import Img19 from '../Assets/xboxone.png'
import Img20 from '../Assets/keyboardandmouse.png'

const Accessproducts = [
    {
        id: 15,
        title:" Ps4 Console",
        price: "$299.99",
        img: Img15,
    },
    {
        id: 16,
        title:" Nintendo",
        price: "$279.99",
        img: Img16
    },
    {
        id: 17,
        title:"Amd Graphics Card",
        price: "$369.99",
        img: Img17,
       
    },
  
    {
        id: 18,
        title:"Ps4 pad",
        price: "$29.99",
        img: Img18,
    },
  
    {
        id: 19,
        title:"Xbox One",
        price: "$229.99",
        img: Img19,
    },
    {
        id: 20,
        title:"Gaming Keyboard and Mouse",
        price: "$59.99",
        img: Img20,
    }
]

export default Accessproducts;